import _assign from 'lodash/assign';
import { GET_USER_SUCCESS, GET_USER_ERROR } from './constants';

const initialState = {
  user: null,
};

function userHandlerReducer(state = initialState, action) {
  switch (action.type) {
  case GET_USER_SUCCESS:
    return _assign({}, state, {
      user: action.user,
    });
  case GET_USER_ERROR:
    return initialState;
  default:
    return state;
  }
}

export default userHandlerReducer;



/** WEBPACK FOOTER **
 ** ./src/containers/user-handler/reducer.js
 **/